/**
 * Audit STO-9 (2026-10-30) — the sidebar badges (`useNavCounts.ts`) used to load once per shell
 * mount and never again, so a quote sent from Cotizar or a depósito created/edited/deleted left
 * them stale until a full reload. This is the smallest fix that keeps `useNavCounts.ts`'s own
 * decision (no shared cache between the badges and the pages, see its docblock): a page that just
 * changed one of the three lists says so, and the hook re-reads them. Plain module, no transport,
 * no React — so a page test that renders without `AppLayout` calls `notifyNavCountsChanged()` into
 * an empty set and nothing happens.
 */
type Listener = () => void;

const listeners = new Set<Listener>();

/** Called by `useNavCounts`; returns the unsubscribe for the effect's cleanup. */
export function subscribeNavCounts(listener: Listener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

/** Called by a page right after a request that changed Solicitudes, Mis cotizaciones or Mis depósitos. */
export function notifyNavCountsChanged(): void {
  listeners.forEach((listener) => listener());
}
